document.addEventListener("turbolinks:load", () => {
  const icModal = document.getElementById('issue-card-modal');
  const icForm = document.getElementById('issue-card-form');
  const cardsField = document.querySelector('.c-issueCard__choices');
  const cards = document.querySelectorAll('.c-issueCard__choice');
  const yellowCard = document.getElementById('yellow_card');
  const redCard = document.getElementById('red_card');
  const operative = document.getElementById('ic-operative-name');
  const reason = document.getElementById('card_reason');
  const redFields = document.querySelectorAll('.for-red-card');
  const expiry = document.getElementById('card_expiry_date');
  const permanent = document.getElementById('permanent');
  const initFieldStyle = "1px solid var(--os-colorGrey3)";
  const errFieldStyle = "1px solid #D81220";
  const path = window.location.pathname;
  const cardIssuancePages = ['/users/profile', '/cards', '/sites'];

  const resetFields = () => {
    cards.forEach(option => {
      const optionType = option.querySelector('.c-issueCard__choiceInput').value;
      option.querySelector('.c-issueCard__card__icon').style.backgroundColor = 'var(--os-colorGrey2)';
      option.querySelector('.c-issueCard__card__' + optionType).style.color = (optionType == 'yellow' ? '#FCA03A' : '#D81220');
      option.querySelector('.c-issueCard__cardBtn').classList.add('c-button--secondary');
    });
    redFields.forEach(div => {
      div.style.display = 'none';
    });
  };

  resetFields();

  cards.forEach(card => {
    card.onclick = (e) => {
      const input = card.querySelector('.c-issueCard__choiceInput');
      const cardType = input.value;

      input.checked = true;

      cards.forEach(option => {
        const optionType = option.querySelector('.c-issueCard__choiceInput').value;
        option.querySelector('.c-issueCard__card__icon').style.backgroundColor = 'var(--os-colorGrey2)';
        option.querySelector('.c-issueCard__card__' + optionType).style.color = (optionType == 'yellow' ? '#FCA03A' : '#D81220');
        option.querySelector('.c-issueCard__cardBtn').classList.add('c-button--secondary');
      });

      card.querySelector('.c-issueCard__card__icon').style.backgroundColor = (cardType == 'yellow' ? '#FCA03A' : '#D81220');
      card.querySelector('.c-issueCard__card__' + cardType).style.color = 'var(--os-colorSnow)';
      card.querySelector('.c-issueCard__cardBtn').classList.remove('c-button--secondary');

      redFields.forEach(div => {
        div.style.display = (cardType == 'red' ? 'inline' : 'none');
      });

      if (cardType === 'yellow') {
        expiry.value = '';
        permanent.checked = false;
      }
    };
  });

  if (cardIssuancePages.includes(path)) {
    permanent.onchange = (e) => {
      expiry.disabled = permanent.checked;
    };

    icForm.addEventListener("submit", function(e) {
      const result = validateForm();

      if (!result.isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert(result.message);

        return false;
      }
    });
  }  

  document.querySelectorAll('.ic-display-form').forEach(button => {
    button.onclick = (e) => {
      e.preventDefault();
      icModal.style.display = 'flex';
      icModal.scrollTop = 0;

      if(button.dataset.issueTo) {
        document.getElementById('ic-appendName').textContent = "to " + button.dataset.issueTo;
        operative.value = button.dataset.issueTo;
        document.getElementById('ic-operative-name-container').style.display = 'none';
        document.querySelector('[name="card[user_id]"]').value = button.dataset.issueToId;
      }
    };
  });

  document.querySelectorAll('[data-action="ic-hide-form"]').forEach(button => {
    button.onclick = (e) => {
      e.preventDefault();

      yellowCard.checked = false;
      redCard.checked = false;
      expiry.disabled = false;
      icForm.reset();
      resetFields();
      cardsField.style.border = "";
      operative.style.border = initFieldStyle;
      reason.style.border = initFieldStyle;
      expiry.style.border = initFieldStyle;

      icModal.style.display = 'none';
    };
  });

  function validateForm() {
    let errMsg = "Please fill out the missing fields:";
    let errFields = [];

    if (!(yellowCard.checked || redCard.checked)) errFields.push("Card Type");

    if (!operative.value) errFields.push("Operative Name");

    if (!reason.value) errFields.push("Reason");

    if (redCard.checked) {
      if (!expiry.value && !permanent.checked) errFields.push("Expiry");
    }

    highlightErrFields(errFields);

    if (errFields.length > 0) {
      return {
        isValid: false,
        message: errMsg + "\n• " + errFields.join("\n• ")
      };
    }

    return { isValid: true };
  }

  function highlightErrFields(errFields) {
    cardsField.style.border = errFields.includes("Card Type") ? errFieldStyle : "";
    operative.style.border = errFields.includes("Operative Name") ? errFieldStyle : initFieldStyle;
    reason.style.border = errFields.includes("Reason") ? errFieldStyle : initFieldStyle;
    expiry.style.border = errFields.includes("Expiry") ? errFieldStyle : initFieldStyle;
  }
});